import React from "react";
import CreatableSelect from "react-select/creatable";

const CreatableReactSelect = (props: any) => {
  return (
    <>
      <div className="form-floating">
        <CreatableSelect
          className="form-select"
          {...props}
          styles={{
            control: (provided: any) => ({
              ...provided,
              minHeight: "36px",
              position: "absolute",
              width: "101%",
              top: "-1px",
              backgroundColor: props.isDisabled ? "#fbfbfb" : "#ffffff",
              left: "-1px",
            }),
          }}
        >
          {props?.children}
        </CreatableSelect>
        <label htmlFor="floatingSelect">{props?.placeholder}</label>
      </div>
    </>
  );
};

export default CreatableReactSelect;
